import { useSelector } from "react-redux";
import { languageSelector } from "redux/language";
import { useConfigQuery } from "redux/services/config";
import { useTranslationsQuery } from "redux/services/translations";
import { ITranslationsData } from "./translations.interfaces";
import { IAppConfigObject } from "../appConfig.interfaces";

export const useTranslations = () => {
  const { language } = useSelector(languageSelector);

  // Fetch config file
  const {
    data: dataConfig,
    isFetching: isFetchingConfig,
    isError: isErrorConfig,
  } = useConfigQuery();

  const getTranslationsUrl = (dataConfig: IAppConfigObject) => {
    if (!isFetchingConfig && !isErrorConfig) {
      const culture = language || dataConfig.PRIMARY_LANGUAGE;
      const query = culture !== "en" ? `&culture=${culture}` : "";

      return `${dataConfig.UMBRACO_TRANSLATIONS_API_BASE_URL}?domain=${dataConfig.TOP_LEVEL_DOMAIN}${query}`;
    } else return "";
  };

  // Fetch translations
  const {
    data: dataTranslations,
    isFetching: isFetchingTranslations,
    isError: isErrorTranslations,
    isLoading: isLoadingTranslations,
  }: {
    data: ITranslationsData;
    isFetching: boolean;
    isError: boolean;
    isLoading: boolean;
  } = useTranslationsQuery(getTranslationsUrl(dataConfig));

  // If no config file
  if (!isFetchingConfig && isErrorConfig) {
    return {
      translations: dataTranslations,
      isFetching: isFetchingConfig,
      isError: isErrorConfig,
      errorText: "😱 😱 😱 We can't find a config.json file",
      isLoading: isLoadingTranslations,
    };
  }

  // Is fetching translations
  if (isFetchingTranslations) {
    return {
      translations: dataTranslations,
      isFetching: isFetchingTranslations,
      isError: isErrorTranslations,
      errorText: "Fetching translations...",
      isLoading: isLoadingTranslations,
    };
  }

  // Success fetching translations
  if (!isFetchingTranslations && !isErrorTranslations) {
    return {
      translations: dataTranslations,
      isFetching: isFetchingTranslations,
      isError: isErrorTranslations,
      errorText: "",
      isLoading: isLoadingTranslations,
    };
  }

  // Error - just error
  return {
    translations: dataTranslations,
    isFetching: true,
    isError: true,
    errorText: "😱 😱 😱 Error fetching content",
    isLoading: isLoadingTranslations,
  };
};
